import React from "react"; 
import Routes from "../routes"; 

export default props => <>{Routes}</>;